<template>
  <Modal :id="id">
    <div slot="body" class="modal-body"></div>
    <div slot="footer" class="modal-footer"></div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "hours-modal"
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "sass/_variables";
</style>